/**
 * VenueFlow FailedList Component
 * 
 * Displays files that failed validation with reasons.
 */

import React from "react";

// ============================================================
// STYLES
// ============================================================
const styles = {
  container: {
    marginTop: 12,
    padding: "14px 16px",
    background: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: 8,
    fontSize: 14,
    color: "#7f1d1d",
  },
  header: {
    fontWeight: 600,
    marginBottom: 10,
    color: "#b91c1c",
  },
  item: {
    padding: "6px 0",
    marginBottom: 10,
    borderBottom: "1px dashed #fca5a5",
  },
  itemLast: {
    marginBottom: 0,
    borderBottom: "none",
  },
  title: {
    fontWeight: 600,
    marginBottom: 4,
    color: "#991b1b",
  },
  reasonList: {
    marginTop: 6,
    marginLeft: 18,
    paddingLeft: 18,
  },
  reason: {
    marginBottom: 4,
    lineHeight: 1.4,
    listStyleType: "circle",
  },
  clearBtn: {
    marginTop: 12,
    background: "#b91c1c",
    color: "#fff",
    padding: "6px 12px",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
    transition: "background 0.15s ease",
  },
  clearBtnHover: {
    background: "#991b1b",
  },
};

// ============================================================
// FAILED ITEM
// ============================================================
function FailedItem({ file, reasons, isLast }) {
  return (
    <div style={{ ...styles.item, ...(isLast ? styles.itemLast : {}) }}>
      <div style={styles.title}>❌ {file.name}</div>
      <ul style={styles.reasonList}>
        {reasons.map((reason, i) => (
          <li key={i} style={styles.reason}>
            {reason}
          </li>
        ))}
      </ul>
    </div>
  );
}

// ============================================================
// FAILED LIST COMPONENT
// ============================================================
export function FailedList({ items, onClear }) {
  const [hovered, setHovered] = React.useState(false);

  if (!items || items.length === 0) return null;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        The following files do not match the content specs for this endpoint
      </div>

      {items.map((item, index) => (
        <FailedItem
          key={`${item.file.name}-${index}`}
          file={item.file}
          reasons={item.reasons}
          isLast={index === items.length - 1}
        />
      ))}

      <button
        type="button"
        style={{
          ...styles.clearBtn,
          ...(hovered ? styles.clearBtnHover : {}),
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClear}
      >
        Clear list
      </button>
    </div>
  );
}

export default FailedList;
